export default __webpack_public_path__ + "static/media/unspecified.7a857024.svg";